// @ts-nocheck
import {faCirclePlay} from "@fortawesome/free-regular-svg-icons";
import {faStar as faStarSolid, faUser} from "@fortawesome/free-solid-svg-icons";
import {faStar as faStarRegular} from "@fortawesome/free-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import useAddFavoriteGame from "../../../../../../hooks/games/useAddFavoriteGame.hook";
import useDeleteFavoriteGame from "../../../../../../hooks/games/useDeleteFavoriteGame.hook";
import {useMiniGames} from "../../../../../../store/useMiniGames";

const CasinoGameCard = ({gameId, name, provider, icon, isFav, tableInfo}) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const setFavoriteGames = useMiniGames(state => state.setFavoriteGames);
  const {addFavoriteGame} = useAddFavoriteGame();
  const {deleteFavoriteGame} = useDeleteFavoriteGame();

  const handleFavorite = e => {
    e.stopPropagation();
    setFavoriteGames({id: gameId, game_provider: provider}, addFavoriteGame, deleteFavoriteGame);
  };

  const players = tableInfo?.totalSeatedPlayers;
  const minBet = tableInfo?.tableLimits?.minBet;
  const maxBet = tableInfo?.tableLimits?.maxBet;

  return (
    <div
      className="group relative rounded-xl overflow-hidden cursor-pointer select-none"
      style={{
        background: "var(--color-surface)",
        transition: "transform 0.22s ease, box-shadow 0.22s ease",
        ...(isHovered && {
          transform: "translateY(-3px) scale(1.02)",
          boxShadow: "0 16px 40px -10px rgba(215,50,168,0.45), 0 4px 16px -4px rgba(0,0,0,0.6)",
        }),
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => navigate(`/games/${provider}/${gameId}`)}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          navigate(`/games/${provider}/${gameId}`);
        }
      }}
      role="button"
      tabIndex={0}
    >
      {/* Image */}
      <div className="relative w-full" style={{aspectRatio: "4/3"}}>
        <img
          alt={`${name} - ${provider}`}
          src={icon}
          className="w-full h-full"
          style={{objectFit: "cover"}}
        />

        {/* Live badge — players online */}
        {players != null && players > 0 && (
          <div
            className="absolute top-2 left-2 flex items-center gap-1 rounded-full px-2 py-0.5 text-white"
            style={{
              background: "linear-gradient(135deg,#fa5400,#d732a8)",
              fontSize: "0.65rem",
              fontWeight: 700,
              letterSpacing: "0.03em",
              backdropFilter: "blur(4px)",
            }}
          >
            <span
              className="rounded-full"
              style={{
                width: 6,
                height: 6,
                background: "#fff",
                boxShadow: "0 0 5px #fff",
                animation: "pulse 1.5s ease-in-out infinite",
                flexShrink: 0,
              }}
            />
            <FontAwesomeIcon icon={faUser} style={{fontSize: "0.6rem"}} />
            {players}
          </div>
        )}

        {/* Favorite button */}
        <button
          type="button"
          aria-label={isFav ? "Quitar de favoritos" : "Agregar a favoritos"}
          className="absolute top-2 right-2 flex items-center justify-center rounded-full"
          style={{
            width: 28,
            height: 28,
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(6px)",
            border: "1px solid rgba(255,255,255,0.1)",
            color: isFav ? "#fa5400" : "rgba(255,255,255,0.6)",
            transition: "color 0.15s, transform 0.15s",
            cursor: "pointer",
          }}
          onClick={handleFavorite}
        >
          <FontAwesomeIcon
            icon={isFav ? faStarSolid : faStarRegular}
            style={{fontSize: "0.7rem"}}
          />
        </button>

        {/* Hover overlay */}
        <div
          className="absolute inset-0 flex flex-col items-center justify-center gap-3"
          style={{
            background: "linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.75) 100%)",
            opacity: isHovered ? 1 : 0,
            transition: "opacity 0.22s ease",
          }}
        >
          <FontAwesomeIcon
            icon={faCirclePlay}
            style={{
              fontSize: "2.8rem",
              color: "#fff",
              filter: "drop-shadow(0 0 12px rgba(215,50,168,0.8))",
              transform: isHovered ? "scale(1)" : "scale(0.85)",
              transition: "transform 0.22s ease",
            }}
          />
          {(minBet != null || maxBet != null) && (
            <div
              className="flex gap-2 text-white rounded-lg px-3 py-1"
              style={{
                background: "rgba(0,0,0,0.5)",
                backdropFilter: "blur(6px)",
                border: "1px solid rgba(255,255,255,0.12)",
                fontSize: "0.7rem",
                fontWeight: 600,
              }}
            >
              {minBet != null && <span>Min {minBet}</span>}
              {minBet != null && maxBet != null && <span style={{opacity: 0.4}}>·</span>}
              {maxBet != null && <span>Max {maxBet}</span>}
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <div
        className="flex items-center gap-1 px-2 py-2"
        style={{background: "var(--color-surface)"}}
      >
        <span
          className="flex-1 truncate text-xs font-semibold"
          style={{color: "var(--color-text)"}}
          title={name}
        >
          {name}
        </span>
        <span
          className="shrink-0 text-xs"
          style={{color: "var(--color-text-tertiary)"}}
          title={provider}
        >
          {provider}
        </span>
      </div>
    </div>
  );
};

export default CasinoGameCard;
